import { useShallow } from 'zustand/shallow'

import { useStore, getSelectedAndCollapsedNodesSelector } from '@app/store'

const useGetSelectedAndCollapsedNodes = (strategyId) =>
  useStore(useShallow((state) => getSelectedAndCollapsedNodesSelector(state, strategyId)))

export default useGetSelectedAndCollapsedNodes
